// extracted by mini-css-extract-plugin
export default {"container":"CheckPointCampaignList_container__zS8qT","head":"CheckPointCampaignList_head__04g7+"};